/**
 * @author mll
 * @description 埋点工具
 * @Date 2023/08/30
 */
import moment from 'moment/moment';

import { utils_tool } from '../tool'

let {
    Storage,
} = utils_tool;

//事件名称:新培训平台使用监测 标识符:New_training_platform
let eventId = 'New_training_platform'


/**
 * 设置埋点事件和事件级变量
 * @returns 
 */
let track = (pathname) => {
    //gio注入失败
    if (!gio) {
        console.error('gio is not found')
        return
    }

    let event = getEvent(pathname) || {};

    //用户或者菜单信息缺失
    if (!event.id || !event.userName || !event.portal_first_menu_name || !event.portal_second_menu_name) {
        console.error('gio user/menu is not found ', pathname, event)
        return
    }

    //⭐️调试输出，上线请注释
    console.log('gio track:', eventId, event)

    //发送track事件
    gio('track', eventId, event)

}

/**
 * 获取event事件内容
 * @returns 
 */
let getEvent = (pathname) => {
    let user = Storage?.getStorage('user') || {}
    return {
        id: user.username,
        userName: user.fullName,
        time: moment().format('YYYY-MM-DD HH:mm:ss'),
        source: 'portal',//wechat / portal / iapp

        dealerName: user.dealerNameList,
        dealerCode: user.dealerCodeList,
        brand: user.brandList,
        userroleid_var: user.positionIdList,
        userrole_var: user.positionNameList,

        //portal_first_menu_name: '',
        //portal_second_menu_name: '',这两个参数getMenu()返回
        ...getMenu(pathname)
    }
}

// 系统管理	用户管理
// 系统管理	角色管理
// 系统管理	角色组管理
// 系统管理	公共配置管理
// 系统管理	消息推送白名单设置
// 系统管理	配置变更信息
// 系统管理	权限下放
// 系统管理	权限设置管理
// 组织结构管理	组织类型管理
// 组织结构管理	组织结构管理
// 组织结构管理	岗位分类管理
// 组织结构管理	岗位管理
// 组织结构管理	人员管理
// 组织结构管理	zoneCode管理
// 经销商管理	经销商管理
// 经销商管理	共建店管理
// 经销商管理	正常经销商管理
// 课程管理	课程管理
// 课程管理	课件管理
// 课程管理	第三方课件管理
// 课程管理	课程分类管理
// 课程管理	系列化课程管理
// 课程管理	系列化课程分类管理
// 考核中心	题目分类管理
// 考核中心	题目管理
// 考核中心	考试分类管理
// 考核中心	考试模版管理
// 考核中心	模版组管理
// 考核中心	考试安排管理
// 考核中心	考试记录管理
// 考核中心	车联考试
// 考核中心	人工批阅
// 培训班级	培训主题管理
// 培训班级	班级管理
// 能力检核	证书中心
// 能力检核	作业管理
// 互动直播	直播管理
// 互动直播	开启直播管理
// 互动直播	直播分类管理
// 互动直播	中目直播资源账号管理
// 调查问卷	问卷管理
// 调查问卷	问卷模版管理
// 互动社区	话题管理
// 互动社区	帖子管理
// 互动社区	活动管理
// 互动社区	点赞 / 踩管理
// 内容知识	内容管理
// 内容知识	内容分类管理
// 内容知识	标签分类管理
// 内容知识	标签管理
// 内容知识	推荐管理
// 内容知识	学习资料管理
// 内容知识	学习资料分类管理
// 内容知识	笔记管理
// 内容知识	应用服务管理
// 内容知识	评论管理
// 内容知识	规则配置管理
// 内容知识	消息任务管理
// 内容知识	栏目应用管理
// 内容知识	栏目应用分类管理
// 内容知识	消息通知记录
// 内容知识	水印管理
// 版本管理	版本管理
// 报表统计	考试记录统计
// 报表统计	在线课程统计
// 报表统计	培训管理统计
// 报表统计	认证统计
// 报表统计	路径报告
// 报表统计	积分统计
// 受众组	受众组管理
// 新学员培训	新学员考核要求管理
// 新学员培训	新开业培训记录
// 新学员培训	新开业人员培训
// 新学员培训	考核要求名称配置管理
// 新学员培训	经销商新人培训
// 新学员培训	岗位兼职管理
// 新学员培训	岗位兼职管理test
// 任务中心	任务中心
// 组件案例展示	数据权限选择组件
// 组件案例展示	数据权限单表单
// 组件案例展示	富文本编辑器
// 组件案例展示	oss上传
// 组件案例展示	复制到剪贴板
// 组件案例展示	图片组件
// 组件案例展示	学员端选项卡
// 组件案例展示	问卷组件
// 微应用	基础实践
// 参训统计	参训统计管理
// 参训统计	新增参训统计
// 参训统计	编辑参训统计
// 数据分析报表	组合报表管理
// 数据分析报表	配置表
// 业务受众设置	业务受众设置
// 话术管理	话术分类管理
// 话术管理	话术管理
// 同步数据管理	同步邮件分类配置
// 路径管理	培训路径管理
// 路径管理	路径评语管理
// 路径管理	路径成绩规则
// 报名管理	报名管理
// 报名管理	报名审核管理
// 报名管理	邀请函模版管理
// 管理数据查看	课程管理
// 管理数据查看	考试记录管理
// 管理数据查看	报名管理
// 管理数据查看	路径管理
// 管理数据查看	作业管理
// 管理数据查看	班级管理
let getMenu = (pathname) => {
    //菜单对应的 menu参数
    let path = {
        '/auth/menu': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '菜单管理'
        },
        '/auth/elementsList': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '元素管理'
        },
        '/auth/userList': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '用户管理'
        },
        '/auth/roleList': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '角色管理'
        },
        '/auth/roleSetsList': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '角色组管理'
        },
        '/common/commonConfig': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '公共配置管理'
        },
        '/perm/whitelist': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '消息推送白名单设置'
        },
        '/data/positionChangeRecordManager': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '配置变更信息'
        },
        '/permissionSetting/list': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '权限下放'
        },
        '/org/managerPermissionsSetting': {
            portal_first_menu_name: '系统管理',
            portal_second_menu_name: '权限设置管理'
        },
        '/org/orgNodeCategory': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '组织类型管理'
        },
        '/org/organization': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '组织结构管理'
        },
        '/org/positionCategory': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '岗位分类管理'
        },
        '/org/position': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '岗位管理'
        },
        '/org/person': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '人员管理'
        },
        '/org/zoneCode': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: 'zoneCode管理'
        },
        '/accountConsolidationRecord': {
            portal_first_menu_name: '组织结构管理',
            portal_second_menu_name: '账号合并'
        },
        '/org/dealer': {
            portal_first_menu_name: '经销商管理',
            portal_second_menu_name: '经销商管理'
        },
        '/org/dealerUnion': {
            portal_first_menu_name: '经销商管理',
            portal_second_menu_name: '共建店管理'
        },
        '/normalDealer/normalDealerList': {
            portal_first_menu_name: '经销商管理',
            portal_second_menu_name: '正常经销商管理'
        },
        '/program/programList': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '课程管理'
        },
        '/program/scheduleList': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '课件管理'
        },
        '/courseware': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '第三方课件管理'
        },
        '/biz/categoryType/program': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '课程分类管理'
        },
        '/series/seriesList': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '系列化课程管理'
        },
        '/biz/categoryType/series': {
            portal_first_menu_name: '课程管理',
            portal_second_menu_name: '系列化课程分类管理'
        },
        '/biz/categoryType/question': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '题目分类管理'
        },
        '/online/bankQuestion': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '题目管理'
        },
        '/biz/categoryType/examination': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '考试分类管理'
        },
        '/online/examTemplate': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '考试模版管理'
        },
        '/online/examTemplateGroup': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '模版组管理'
        },
        '/online/exam': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '考试安排管理'
        },
        '/online/examRecord': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '考试记录管理'
        },
        '/cle/examManager': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '车联考试'
        },
        '/online/subjectiveReview': {
            portal_first_menu_name: '考核中心',
            portal_second_menu_name: '人工批阅'
        },
        '/face/offlineProgramList': {
            portal_first_menu_name: '培训班级',
            portal_second_menu_name: '培训主题管理'
        },
        '/face/classList': {
            portal_first_menu_name: '培训班级',
            portal_second_menu_name: '班级管理'
        },
        '/cert/certList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '证书中心'
        },
        '/personalCert/personalCertList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '证书中心'
        },
        '/certApply/certApplyList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '证书中心'
        },
        '/biz/categoryType/cert': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '证书中心'
        },
        '/homework/homeworkList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/homework/homeworkRecordList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/homework/homeworkRecordReviewList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/biz/categoryType/homeworkLabel': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/homework/homeworkLabel/label': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/biz/categoryType/homework': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/homework/homeworkList/homeworkRecordList': {
            portal_first_menu_name: '能力检核',
            portal_second_menu_name: '作业管理'
        },
        '/live/liveList': {
            portal_first_menu_name: '互动直播',
            portal_second_menu_name: '直播管理'
        },
        '/live/hostList': {
            portal_first_menu_name: '互动直播',
            portal_second_menu_name: '开启直播管理'
        },
        '/biz/categoryType/interactLive': {
            portal_first_menu_name: '互动直播',
            portal_second_menu_name: '直播分类管理'
        },
        '/interactLiveResources': {
            portal_first_menu_name: '互动直播',
            portal_second_menu_name: '中目直播资源账号管理'
        },
        '/biz/survey': {
            portal_first_menu_name: '调查问卷',
            portal_second_menu_name: '问卷管理'
        },
        '/biz/surveyTemplate': {
            portal_first_menu_name: '调查问卷',
            portal_second_menu_name: '问卷模版管理'
        },
        '/community/topic': {
            portal_first_menu_name: '互动社区',
            portal_second_menu_name: '话题管理'
        },
        '/interact/community/invitation': {
            portal_first_menu_name: '互动社区',
            portal_second_menu_name: '帖子管理'
        },
        '/interact/activity': {
            portal_first_menu_name: '互动社区',
            portal_second_menu_name: '活动管理'
        },
        '/operateRecord': {
            portal_first_menu_name: '互动社区',
            portal_second_menu_name: '点赞'
        },
        '/content/contentManage': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '内容管理'
        },
        '/biz/categoryType/content': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '内容分类管理'
        },
        '/biz/categoryType/label': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '标签分类管理'
        },
        '/content/contentLabel/label': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '标签管理'
        },
        '/featured/management': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '推荐管理'
        },
        '/content/learningMaterialsManage': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '学习资料管理'
        },
        '/biz/categoryType/learningMaterials': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '学习资料分类管理'
        },
        '/notes/notesManage': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '笔记管理'
        },
        '/application/applicationManage': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '应用服务管理'
        },
        '/commentManage': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '评论管理'
        },
        '/rule/configureList': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '规则配置管理'
        },
        '/message/MessageTask': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '消息任务管理'
        },
        '/application/applicationColumn': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '栏目应用管理'
        },
        '/biz/categoryType/applicationColumn': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '栏目应用分类管理'
        },
        '/message/noticeRecord': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '消息通知记录'
        },
        '/watermark': {
            portal_first_menu_name: '内容知识',
            portal_second_menu_name: '水印管理'
        },
        '/version/management': {
            portal_first_menu_name: '版本管理',
            portal_second_menu_name: '版本管理'
        },
        '/examRecordStatistics/examScoreStatistics': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '考试记录统计'
        },
        '/onlineCourseStatistics/onlineCourseCompletionStatus': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '在线课程统计'
        },
        '/offlineTrainingStatistics/statisticsOfflineTrainees': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '培训管理统计'
        },
        '/pathReport/personalPathTaskDetails': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '路径报告'
        },
        '/audience/group': {
            portal_first_menu_name: '受众组',
            portal_second_menu_name: '受众组管理'
        },
        '/requirement/requirementList': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '新学员考核要求管理'
        },
        '/requirement/requirementRecord': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '新开业培训记录'
        },
        '/requirementPersonnel/requirementPersonnelList': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '新开业人员培训'
        },
        '/requirementConfig/requirementConfigList': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '考核要求名称配置管理'
        },
        '/dealerNewPersonTrain/dealerNewPersonTrainList': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '经销商新人培训'
        },
        '/dealerNewPersonTrain/requirementPartTimePosition': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '岗位兼职管理'
        },
        '/dealerNewPersonTrain/requirementPartTimePositionTest': {
            portal_first_menu_name: '新学员培训',
            portal_second_menu_name: '岗位兼职管理test'
        },
        '/taskInfo': {
            portal_first_menu_name: '任务中心',
            portal_second_menu_name: '任务中心'
        },
        '/demo/dataAuthSelect': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '数据权限选择组件'
        },
        '/demo/wizAuthority': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '数据权限单表单'
        },
        '/demo/editeorDemo': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '富文本编辑器'
        },
        '/demo/ossUpload': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: 'oss上传'
        },
        '/demo/copy': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '复制到剪贴板'
        },
        '/demo/image': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '图片组件'
        },
        '/demo/stutabs': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '学员端选项卡'
        },
        '/demo/questionnair': {
            portal_first_menu_name: '组件案例展示',
            portal_second_menu_name: '问卷组件'
        },
        '/trainingStatistics/trainingStatisticsList': {
            portal_first_menu_name: '参训统计',
            portal_second_menu_name: '参训统计管理'
        },
        '/trainingStatistics/trainingStatisticsList/trainingStatisticsAdd': {
            portal_first_menu_name: '参训统计',
            portal_second_menu_name: '新增参训统计'
        },
        '/trainingStatistics/trainingStatisticsList/trainingStatisticsUpd': {
            portal_first_menu_name: '参训统计',
            portal_second_menu_name: '编辑参训统计'
        },
        '/dataReport/reportConfigList': {
            portal_first_menu_name: '数据分析报表',
            portal_second_menu_name: '组合报表管理'
        },
        '/dataReport/tableConfig': {
            portal_first_menu_name: '数据分析报表',
            portal_second_menu_name: '配置表'
        },
        '/permissions/list': {
            portal_first_menu_name: '业务受众设置',
            portal_second_menu_name: '业务受众设置'
        },
        '/biz/categoryType/verbalTrick': {
            portal_first_menu_name: '话术管理',
            portal_second_menu_name: '话术分类管理'
        },
        '/verbalTrick': {
            portal_first_menu_name: '话术管理',
            portal_second_menu_name: '话术管理'
        },
        '/syncEmailConfigManager': {
            portal_first_menu_name: '同步数据管理',
            portal_second_menu_name: '同步邮件分类配置'
        },
        '/trainPath': {
            portal_first_menu_name: '路径管理',
            portal_second_menu_name: '培训路径管理'
        },
        '/comment': {
            portal_first_menu_name: '路径管理',
            portal_second_menu_name: '路径评语管理'
        },
        '/trainPathStageScoreRule': {
            portal_first_menu_name: '路径管理',
            portal_second_menu_name: '路径成绩规则'
        },
        '/workflow/apply': {
            portal_first_menu_name: '报名管理',
            portal_second_menu_name: '报名管理'
        },
        '/workflow/applyVerify': {
            portal_first_menu_name: '报名管理',
            portal_second_menu_name: '报名审核管理'
        },
        '/biz/inviteLetter': {
            portal_first_menu_name: '报名管理',
            portal_second_menu_name: '邀请函模版管理'
        },
        '/perm/programPerm/programList': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '课程管理'
        },
        '/perm/examRecordPerm': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '考试记录管理'
        },
        '/perm/applyPerm': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '报名管理'
        },
        '/perm/trainPathPerm': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '路径管理'
        },
        '/perm/homeworkListPerm': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '作业管理'
        },
        '/perm/classListPerm': {
            portal_first_menu_name: '管理数据查看',
            portal_second_menu_name: '班级管理'
        },
        '/biz/categoryType/labelMg': {
            portal_first_menu_name: '标签管理',
            portal_second_menu_name: '标签分类管理'
        },
        '/biz/label': {
            portal_first_menu_name: '标签管理',
            portal_second_menu_name: '标签管理'
        },
        '/biz/label/labelUser': {
            portal_first_menu_name: '标签管理',
            portal_second_menu_name: '标签用户管理'
        },
        '/data/syncTimsTransfer': {
            portal_first_menu_name: '平台管理',
            portal_second_menu_name: '业务数据迁移'
        },
        '/onlineCourseStatistics/courseLearningStatistics': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '在线课程统计'
        },
        '/onlineCourseStatistics/orgCourseLearningStatistics': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '在线课程统计'
        },
        '/examRecordStatistics/orgExaminationStatistics': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '考试记录统计'
        },
        '/examRecordStatistics/orgJobExaminationStatistics': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '考试记录统计'
        },
        '/offlineTrainingStatistics/orgStatisticsOfflineTrainingAndLearning': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '培训管理统计'
        },
        '/offlineTrainingStatistics/statisticsOfflineTrainingAndLearning': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '培训管理统计'
        },
        '/pathReport/personalPathTaskCompletion': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '路径报告'
        },
        '/pathReport/personalPathScoreCompletion': {
            portal_first_menu_name: '报表统计',
            portal_second_menu_name: '路径报告'
        },
        '/report/dimStudentReport': {
            portal_first_menu_name: '学员查询报表',
            portal_second_menu_name: '学员查询报表'
        }
    }

    for (let key in path) {
        if (pathname === key) {
            return path[key]
        }
    }
}

export default { track, getEvent, getMenu }